<template>
  <container-list-extend title="Fournisseur">
    <template v-slot:title>
      <div
        class="p-1 flex-grow-1 d-flex justify-content-between"
        v-if="fournisseur.description"
      >
        <div class="d-flex align-items-center">
          <!-- Pastille de statut -->
          <div
            class="status-dot mr-2"
            :class="{
              'status-active': fournisseur.etat === 1,
              'status-inactive': fournisseur.etat === 0
            }"
            :title="fournisseur.etat === 1 ? 'Actif' : 'Inactif'"
          ></div>
          <!-- Nom du fournisseur -->
          <div>{{ fournisseur.description }}</div>
        </div>
      </div>
      <div class="p-1 flex-grow-1 text-primary" v-if="!fournisseur.description">
        Nouveau fournisseur
      </div>
    </template>
    <template v-slot:form>
      <div class="p-3">
        <div class="mb-3">
          <menuItem
            title="Informations"
            @click="tab = 'Informations'"
            :active="tab === 'Informations'"
            icon="truck"
          ></menuItem>
          <menuItem
            title="Agrément"
            @click="tab = 'Agrement'"
            :active="tab === 'Agrement'"
            icon="file-text"
          ></menuItem>
          <menuItem
            title="Evaluation"
            @click="tab = 'evaluation'"
            :active="tab === 'evaluation'"
            icon="users"
          ></menuItem>
        </div>
        <base-form
          class="w-100"
          :deleteBtn="canDelete"
          :updateBtn="canUpdate"
          @click="updateFournisseur(fournisseur)"
          @delete="deleteFournisseur(fournisseur)"
          :loading="loading"
        >
          <div v-show="tab === 'Informations'" class="mb-3">
            <base-form-row row>
              <BaseInput
                class
                v-model="fournisseur.description"
                inputText="Nom du fournisseur"
                :errors="feedback.description"
                :iconActive="true"
              ></BaseInput>
              <base-select
                inputText="Etat"
                v-model.number="etat"
                :options="[
                  { id: 0, description: 'Inactif' },
                  { id: 1, description: 'Actif' }
                ]"
              ></base-select>
            </base-form-row>

            <base-form-row row>
              <base-input-date-picker
                v-model="fournisseur.date_debut"
                inputText="Date début"
                :errors="feedback.date_debut"
              ></base-input-date-picker>

              <base-input-date-picker
                v-model="fournisseur.date_fin"
                inputText="Date fin"
                :errors="feedback.date_fin"
              ></base-input-date-picker>
            </base-form-row>

            <base-form-row row>
              <BaseInput
                class
                v-model="fournisseur.raison_sociale"
                inputText="SIRET"
                :errors="feedback.raison_sociale"
                :iconActive="true"
              ></BaseInput>
              <BaseInput
                class
                v-model="fournisseur.activite"
                inputText="Activité"
                :errors="feedback.activite"
                :iconActive="true"
              ></BaseInput>
            </base-form-row>

            <base-form-row row>
              <BaseInput
                class
                v-model="fournisseur.type_service"
                inputText="Prestation ou matériel acheté"
                :errors="feedback.type_service"
                :iconActive="true"
              ></BaseInput>
              <base-select
                inputText="Présent dans e-attestations"
                v-model.number="e_attestation"
                :options="[
                  { id: 0, description: 'Non présent dans e-attestations' },
                  { id: 1, description: 'Présent dans e-attestations' }
                ]"
              ></base-select>
            </base-form-row>

            <base-form-row row>
              <BaseInput
                class
                v-model="fournisseur.adresse"
                inputText="Adresse"
                :errors="feedback.adresse"
                :iconActive="true"
              ></BaseInput>
            </base-form-row>
            <base-form-row row>
              <BaseInput
                class
                v-model="fournisseur.telephone"
                inputText="Téléphone"
                :errors="feedback.telephone"
                :iconActive="true"
              ></BaseInput>
              <BaseInput
                class
                v-model="fournisseur.email"
                inputText="Mail"
                :errors="feedback.email"
                :iconActive="true"
              ></BaseInput>
            </base-form-row>

            <base-form-row row>
              <BaseInput
                class
                v-model="fournisseur.certification_autre"
                inputText="Autre"
                :errors="feedback.certification_autre"
                :iconActive="true"
              ></BaseInput>
            </base-form-row>

            <base-form-row row>
              <base-input-area
                v-model="fournisseur.commentaire"
                text="Commentaire"
                :errors="feedback.commentaire"
              ></base-input-area>
            </base-form-row>

            <div style="display: none;">
              Sociétés
              <div v-for="societe in data.societes" :key="'soc_' + societe.id">
                <Checkbox
                  v-model="fournisseur.societes[societe.id]"
                  :text="societe.description"
                ></Checkbox>
              </div>
            </div>

            <uploader
              v-if="fournisseur.id"
              class="mt-5"
              id="document_fournisseur"
              url="/upload/document"
              title="Vos fichiers"
              :file_system="'FOURNISSEUR'"
              :file_field="'materiel_fournisseur'"
              :file_key="fournisseur.id"
            ></uploader>
          </div>

          <div class="pl-3 pr-3 w-100">
            <div v-show="tab === 'Agrement'" class="mb-3">
              Certifications
              <base-form-row row>
                <Checkbox
                  v-model="certification_1"
                  text="Certifié Nucléaire sous rayonnement ionisant (CRFRI)"
                ></Checkbox>
              </base-form-row>

              <base-form-row row>
                <Checkbox
                  v-model="certification_2"
                  text="Certifié Chimie / Pétrochimie (MASE)"
                ></Checkbox>
              </base-form-row>

              <base-form-row row>
                <Checkbox
                  v-model="certification_3"
                  text="Certifié Bureau d'étude sur AIP / EIP (ISO 9001 / 19443)"
                ></Checkbox>
              </base-form-row>

              <base-form-row row>
                <Checkbox
                  v-model="certification_4"
                  text="Certifié Bureau d'étude simple (ISO 9001)"
                ></Checkbox>
              </base-form-row>

              <base-form-row row class="mt-4">
                <Checkbox
                  v-model="agrement_obligatoire"
                  text="Fournisseur nécessitant un agrément"
                ></Checkbox>
                <base-select
                  inputText="Statut de l'agrément"
                  v-model.number="agree"
                  :options="[
                    { id: 0, description: 'Non agréé' },
                    { id: 1, description: 'Agréé' },
                    { id: 2, description: 'Sous-traitant' },
                    { id: 3, description: 'En cours' }
                  ]"
                ></base-select>
              </base-form-row>
            </div>

            <div v-show="tab === 'evaluation'" class="mb-3">
              <BaseToolBar
                title="Evaluations"
                subtitle="Liste des évaluations du fournisseur"
              >
                <BaseButton
                  class="btn btn-primary ml-3"
                  v-tooltip="'Ajouter une évaluation'"
                  @click="storeFournisseurEval"
                  :loading="loading"
                  icon="plus"
                ></BaseButton>
              </BaseToolBar>
              <div>
                <div
                  v-for="evaluation in evaluationsfiltered"
                  :key="evaluation.id"
                >
                  <fournisseurs-item-eval
                    :evaluation="evaluation"
                  ></fournisseurs-item-eval>
                </div>
              </div>
            </div>
          </div>
        </base-form>
      </div>
    </template>
  </container-list-extend>
</template>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import { errHandler } from "@/helpers.js";
import { mapMultiRowFields } from "vuex-map-fields";

import ContainerListExtend from "@/components/containers/ContainerListExtend.vue";
import BaseForm from "@/components/bases/Form.vue";
import BaseFormRow from "@/components/bases/FormRow.vue";
import BaseInput from "@/components/bases/Input.vue";
import BaseInputArea from "@/components/bases/InputArea.vue";
import Uploader from "@/components/bases/Uploader.vue";
import FournisseursItemEval from "@/components/fournisseurs/FournisseursItemEval.vue";
import BaseToolBar from "@/components/bases/ToolBar.vue";
import BaseButton from "@/components/bases/Button.vue";
import BaseSelect from "@/components/bases/Select.vue";
import BaseInputDatePicker from "@/components/bases/InputDatePicker.vue";

import menuItem from "@/components/qsser/menuItem.vue";

import Checkbox from "@/components/bases/Checkbox.vue";

export default {
  name: "FournisseursItem",
  components: {
    ContainerListExtend,
    BaseForm,
    BaseFormRow,
    BaseInput,
    BaseInputArea,
    Uploader,
    FournisseursItemEval,
    BaseToolBar,
    BaseButton,
    BaseSelect,
    Checkbox,
    BaseInputDatePicker,
    menuItem
  },
  data() {
    return {
      feedback: {},
      loading: false,
      etat: this.fournisseur.etat,
      agree: this.fournisseur.agree,
      e_attestation: this.fournisseur.e_attestation,
      certification_1: this.fournisseur.certification_1,
      certification_2: this.fournisseur.certification_2,
      certification_3: this.fournisseur.certification_3,
      certification_4: this.fournisseur.certification_4,
      agrement_obligatoire: this.fournisseur.agrement_obligatoire,
      tab: "Informations"
    };
  },
  props: ["fournisseur", "canDelete", "canUpdate"],
  computed: {
    ...mapGetters({ data: "materiel/data" }),
    ...mapMultiRowFields("materiel", ["evaluations"]),

    evaluationsfiltered: function() {
      return this.evaluations.filter(
        evaluation => evaluation.fournisseur_id === this.fournisseur.id
      );
    }
  },
  methods: {
    ...mapActions({
      _updateFournisseur: "materiel/updateFournisseur",
      _deleteFournisseur: "materiel/deleteFournisseur",
      _storeFournisseurEval: "materiel/createFournisseurEval"
    }),
    updateFournisseur: function(fournisseur) {
      this.feedback = {};
      this.loading = true;
      this.fournisseur.etat = this.etat;
      this.fournisseur.agree = this.agree;
      this.fournisseur.e_attestation = this.e_attestation;

      this.fournisseur.certification_1 = this.certification_1;
      this.fournisseur.certification_2 = this.certification_2;
      this.fournisseur.certification_3 = this.certification_3;
      this.fournisseur.certification_4 = this.certification_4;

      this.fournisseur.agrement_obligatoire = this.agrement_obligatoire;

      this._updateFournisseur(fournisseur)
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    },
    deleteFournisseur: function(fournisseur) {
      if (!window.confirm("Confirmer la suppression de l'élément ?"))
        return null;
      this.feedback = {};
      this.loading = true;
      this._deleteFournisseur(fournisseur)
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    },
    storeFournisseurEval: function() {
      this.feedback = {};
      this.loading = true;
      this._storeFournisseurEval(this.fournisseur)
        //.catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
<style lang="css">
.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.status-active {
  background-color: #28a745; /* Vert Bootstrap */
  box-shadow: 0 0 5px rgba(40, 167, 69, 0.5);
}

.status-inactive {
  background-color: #dc3545; /* Rouge Bootstrap */
  box-shadow: 0 0 5px rgba(220, 53, 69, 0.5);
}
</style>
